// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --main-color: main-palette(500);
  --main-bg: #fff;
  --boxed-width: 1140px;
}

.navbar {
  --navbar-bg: #fff;
  --navbar-color: var(--main-color);
  background: var(--navbar-bg);
  color: var(--navbar-color);
  display: block;
  transition: box-shadow 0.2s ease-in-out;
  will-change: box-shadow;
  width: 100%;
  z-index: 990;
  font-family: "Nunito Sans", sans-serif;
  object-fit: contain;
  font-size: 16px;
  padding-top: 16px;
  padding-bottom: 16px;
  box-shadow: 0px 4px 6px -2px rgba(0, 0, 0, 0.08);
}
@media only screen and (max-width: 1599px) {
  .navbar {
    font-size: 14px;
  }
}
@media only screen and (max-width: 1366px) {
  .navbar {
    font-size: 14px;
  }
}
@media only screen and (max-width: 1199px) {
  .navbar {
    padding-top: 8px;
    padding-bottom: 8px;
  }
}
.navbar .navbar-toggler:focus {
  box-shadow: none;
}
@media only screen and (max-width: 1366px) {
  .navbar .navbar-nav .nav-link {
    white-space: nowrap;
  }
}
@media only screen and (max-width: 1400px) {
  .navbar .navbar-collapse {
    width: 100%;
    background-color: #ffffff;
    position: absolute;
    right: 0;
    top: 90px;
    margin-top: 30px;
  }
}
@media only screen and (max-width: 767px) {
  .navbar .navbar-collapse {
    top: 78px;
  }
}
@media only screen and (max-width: 767px) {
  .navbar .navbar-brand img {
    width: 100px;
  }
}
@media only screen and (max-width: 575px) {
  .navbar .navbar-brand img {
    width: 80px;
  }
}
@media only screen and (max-width: 1599px) {
  .navbar .navbar-brand img {
    width: 120px;
  }
}
.navbar .navbar-wrap {
  align-items: center;
  background: inherit;
  display: flex;
  height: 100%;
  justify-content: space-between;
  margin: 0 auto;
  min-height: inherit;
  padding: 0 0.7142857143rem;
  position: relative;
}
.navbar .navbar-wrap > * {
  margin: 0 0.7142857143rem;
}
.navbar .navbar-wrap .navbar-close {
  color: inherit;
  cursor: pointer;
  font-size: 30px;
  position: absolute;
  right: 0.7142857143rem;
  top: 1.0714285714rem;
  width: auto !important;
  z-index: 1;
}
.navbar .navbar-wrap .add-patient {
  height: 100%;
  padding: 1.4285714286rem 2.8571428571rem;
}
.navbar .navbar-wrap .assistant-menu {
  display: block;
  padding: 0 2.8571428571rem 1.4285714286rem;
}
.navbar .navbar-wrap .assistant-menu .link {
  color: inherit;
  display: block;
  font-weight: 700;
  opacity: 0.3;
  padding: 0.3571428571rem 0;
  transition: opacity 0.2s ease-in-out;
}
.navbar .navbar-wrap .assistant-menu .link .link-icon {
  margin-right: 0.7142857143rem;
  padding: 0;
  font-size: 1.3em;
}
.navbar .navbar-wrap .assistant-menu .link:hover {
  opacity: 1;
}
.navbar .navbar-wrap .navbar-toggle {
  align-items: center;
  color: inherit;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  height: 40px;
  justify-content: center;
  width: 35px;
}
.navbar .navbar-wrap .navbar-toggle span {
  background: #1f2022;
  display: block;
  height: 3px;
  margin: 4px 0;
  width: 35px;
}
.navbar.boxed .navbar-wrap {
  max-width: 1140px;
  max-width: var(--boxed-width);
}
@media only screen and (max-width: 991px) {
  .navbar.horizontal-vertical {
    display: flex;
    justify-content: flex-end;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    transform: translateX(-17.1428571429rem);
    transition: transform 0.2s ease-in-out;
    width: 17.1428571429rem;
    will-change: transform, width;
    z-index: 997;
  }
  .navbar.horizontal-vertical .navbar-wrap {
    align-items: flex-start;
    flex-direction: column;
    height: 100%;
    justify-content: flex-start;
    overflow: auto;
    padding: 0;
    width: 17.1428571429rem;
  }
  .navbar.horizontal-vertical .navbar-wrap > * {
    margin: 0;
    width: 100%;
  }
  .navbar.horizontal-vertical.opened {
    transform: translateX(0);
  }
}
.navbar.vertical {
  --navbar-bg: #fbfbfb;
  display: flex;
  justify-content: flex-end;
  height: 100%;
  left: 0;
  overflow: auto;
  position: absolute;
  top: 0;
  transition: transform 0.2s ease-in-out;
  width: 17.1428571429rem;
  will-change: transform, width;
  -webkit-overflow-scrolling: touch;
  z-index: 998;
}
@media only screen and (max-width: 991px) {
  .navbar.vertical {
    transform: translateX(-17.1428571429rem);
  }
}
.navbar.vertical .navbar-wrap {
  align-items: flex-start;
  flex-direction: column;
  height: 100%;
  justify-content: flex-start;
  padding: 0;
  width: 17.1428571429rem;
}
.navbar.vertical .navbar-wrap > * {
  margin: 0;
  width: 100%;
}
.navbar.vertical.opened {
  transform: translateX(0);
}`, "",{"version":3,"sources":["webpack://./src/assets/sass/_variables.scss","webpack://./src/layout/components/navbar/Navbar.scss"],"names":[],"mappings":"AAmGA;EACE,+BAAA;EACA,eAAA;EACA,qBAAA;AClGF;;AAFA;EAEE,iBAAA;EACA,iCAAA;EAEA,4BAAA;EACA,0BAAA;EACA,cAAA;EACA,uCAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,sCDyHY;ECxHZ,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,gDAAA;AAGF;AADE;EAnBF;IAoBI,eAAA;EAIF;AACF;AAHE;EAtBF;IAuBI,eAAA;EAMF;AACF;AALE;EAzBF;IA0BI,gBAAA;IACA,mBAAA;EAQF;AACF;AALI;EACE,gBAAA;AAON;AAFM;EADF;IAEI,mBAAA;EAKN;AACF;AAAM;EADJ;IAEM,WAAA;IACA,yBAAA;IACA,kBAAA;IACA,QAAA;IACA,SAAA;IACA,gBAAA;EAGN;AACF;AAFM;EATJ;IAUM,SAAA;EAKN;AACF;AADM;EADF;IAEI,YAAA;EAIN;AACF;AAHM;EAJF;IAKI,WAAA;EAMN;AACF;AALM;EAPF;IAQI,YAAA;EAQN;AACF;AAFE;EACE,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;EACA,8BAAA;EACA,cAAA;EACA,mBAAA;EACA,0BAAA;EACA,kBAAA;AAIJ;AAFI;EACE,yBAAA;AAIN;AAFI;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,sBDgCO;EC/BP,oBAAA;EACA,sBAAA;EACA,UAAA;AAIN;AAFI;EACE,YAAA;EACA,wCAAA;AAIN;AAFI;EACE,cAAA;EACA,0CAAA;AAIN;AAFM;EACE,cAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;EACA,0BAAA;EACA,oCAAA;AAIR;AAFQ;EACE,6BDUG;ECTH,UAAA;EACA,gBAAA;AAIV;AAFQ;EACE,UAAA;AAIV;AAAI;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,uBAAA;EACA,WAAA;AAEN;AAAM;EACE,mBAAA;EACA,cAAA;EACA,WAAA;EACA,aAAA;EACA,WAAA;AAER;AAGI;EACE,iBDtCQ;ECuCR,6BAAA;AADN;AAKI;EADF;IAEI,aAAA;IACA,yBAAA;IACA,YAAA;IACA,OAAA;IACA,kBAAA;IACA,MAAA;IACA,wCAAA;IACA,sCAAA;IACA,uBDDkB;ICElB,6BAAA;IACA,YAAA;EAFJ;EAII;IACE,uBAAA;IACA,sBAAA;IACA,YAAA;IACA,2BAAA;IACA,cAAA;IACA,UAAA;IACA,uBDZgB;ECUtB;EAIM;IACE,SAAA;IACA,WAAA;EAFR;EAKI;IACE,wBAAA;EAHN;AACF;AAME;EACE,oBAAA;EAEA,aAAA;EACA,yBAAA;EACA,YAAA;EACA,OAAA;EACA,cAAA;EACA,kBAAA;EACA,MAAA;EACA,sCAAA;EACA,uBDnCoB;ECoCpB,6BAAA;EACA,iCAAA;EACA,YAAA;AALJ;AAOI;EAhBF;IAiBI,wCAAA;EAJJ;AACF;AAMI;EACE,uBAAA;EACA,sBAAA;EACA,YAAA;EACA,2BAAA;EACA,UAAA;EACA,uBDlDkB;AC8CxB;AAKM;EACE,SAAA;EACA,WAAA;AAHR;AAMI;EACE,wBAAA;AAJN","sourcesContent":["@import './mixins';\n\n//Main palette\n$palette: (\n  50: #e4e4e4,\n  100: #bcbcbd,\n  200: #8f9091,\n  300: #626364,\n  400: #414143,\n  500: #1f2022,\n  600: #1b1c1e,\n  700: #171819,\n  800: #121314,\n  900: #0a0b0c,\n  A100: #52ffff,\n  A200: #1fffff,\n  A400: #00ebeb,\n  A700: #00d2d2,\n  bloulder100 : #E7E7E7,\n  bloulder400 : #7B7B7B,\n  bloulder500 : #6D6D6D,\n  bloulder600 : #5D5D5D,\n  bloulder900 : #3D3D3D,\n  bloulder950 : #262626,\n  perano50 : #F5F8FF,\n  perano400 : #9099E9,\n  perano500 : #7578DF,\n  Lavender500: #BD80C2\n);\n\n$contrast: (\n  50: #000000,\n  100: #000000,\n  200: #000000,\n  300: #ffffff,\n  400: #ffffff,\n  500: #ffffff,\n  600: #ffffff,\n  700: #ffffff,\n  800: #ffffff,\n  900: #ffffff,\n  A100: #000000,\n  A200: #000000,\n  A400: #000000,\n  A700: #000000\n);\n\n@function main-palette($key: $palette) {\n  @return map-get($palette, $key);\n}\n@function main-contrast($key: $palette) {\n  @return map-get($contrast, $key);\n}\n\n//Accent palette\n$accent-palette: (\n  50: #e7edff,\n  100: #c2d3fe,\n  200: #99b6fd,\n  300: #7098fc,\n  400: #5282fc,\n  500: #336cfb,\n  600: #2e64fa,\n  700: #2759fa,\n  800: #204ff9,\n  900: #143df8,\n  A100: #ffffff,\n  A200: #f4f6ff,\n  A400: #c1caff,\n  A700: #a7b4ff\n);\n\n$accent-contrast: (\n  50: #000000,\n  100: #000000,\n  200: #000000,\n  300: #000000,\n  400: #000000,\n  500: #ffffff,\n  600: #ffffff,\n  700: #ffffff,\n  800: #ffffff,\n  900: #ffffff,\n  A100: #000000,\n  A200: #000000,\n  A400: #000000,\n  A700: #000000\n);\n\n$themeBtnBg : linear-gradient(90deg, #DBCDF0 15%, #F2C6DE 40%)\n;\n\n@function accent-palette($key: $accent-palette) {\n  @return map-get($accent-palette, $key);\n}\n@function accent-contrast($key: $accent-palette) {\n  @return map-get($accent-contrast, $key);\n}\n\n:root {\n  --main-color: main-palette(500);\n  --main-bg: #fff;\n  --boxed-width: 1140px;\n}\n\n$main-color: main-palette(500);\n$main-bg: #fff;\n$boxed-width: 1140px;\n\n$success-color: #b7ce63;\n$success-contrast: #000;\n$info-color: #64b5f6;\n$info-contrast: #000;\n$warning-color: #e9e165;\n$warning-contrast: #000;\n$error-color: #ed5564;\n$error-contrast: #fff;\n$paragraph-text: main-palette(300);\n\n//Main\n$main-fs: 14px;\n$main-ff: 'Lato', sans-serif;\n$main-fw: 400;\n$module: 10px;\n$main-lh: ($module * 2 / $main-fs);\n$module-rem: ($module / $main-fs) * 1rem;\n$shape: 6px;\n$shadow: 0 18px 24px rgba(#000, 0.12);\n$shadow-consulatant: 0 3px 10px rgba(#000, 0.12);\n$shadow-hover: 0px 8px 24px rgba(#000, 0.12);\n$animation: ease-in-out;\n\n//Second\n$second-ff: $main-ff;\n\n$fontNunito : 'Nunito Sans',sans-serif;\n\n//Media\n$max543: 'only screen and (max-width: 543px)';\n$min544: 'only screen and (min-width: 544px)';\n$max575: 'only screen and (max-width: 575px)';\n$max767: 'only screen and (max-width: 767px)';\n$min768: 'only screen and (min-width: 768px)';\n$max991: 'only screen and (max-width: 991px)';\n$min992: 'only screen and (min-width: 992px)';\n$max1199: 'only screen and (max-width: 1199px)';\n$max1366: 'only screen and (max-width: 1366px)';\n$max1400: 'only screen and (max-width: 1400px)';\n$max1599: 'only screen and (max-width: 1599px)';\n$min1200: 'only screen and (min-width: 1200px)';\n\n//Headers\n$headers-ff: $second-ff;\n$headers-fw: 700;\n\n//navbar\n$navbar-bg: #eeeeef;\n$navbar-color: rgba(main-palette(500), 0.5);\n$vertical-navbar-width: $module-rem * 24;\n\n//footer\n$footer-height: $module-rem * 6;\n\n//Preloader\n$loader-overlay-bg: #fff;\n$loader-color: accent-palette(500);\n\n\n$themeShadow : 0px 0px 6px 2px rgba(212, 196, 236, 0.6);\n$altBtnShadow : 0px 0px 4px 0px rgba(212, 196, 236, 0.6);\n$pinkColor : main-palette(Lavender500);\n$Lavender200 : #EEDDF1;\n$themeBlack : main-palette(bloulder950);\n$bloulder500 : main-palette(bloulder500);\n$bloulder600 : main-palette(bloulder600);\n$bloulder900 : main-palette(bloulder900);\n$perano50 : main-palette(perano50);\n$perano400 : main-palette(perano400);\n","@import \"../../../assets/sass/variables\";\n\n.navbar {\n  $_color: $main-color;\n  --navbar-bg: #fff;\n  --navbar-color: #{var(--main-color)};\n\n  background: var(--navbar-bg);\n  color: var(--navbar-color);\n  display: block;\n  transition: box-shadow 0.2s $animation;\n  will-change: box-shadow;\n  width: 100%;\n  z-index: 990;\n  font-family: $fontNunito;\n  object-fit: contain;\n  font-size: 16px;\n  padding-top: 16px;\n  padding-bottom: 16px;\n  box-shadow: 0px 4px 6px -2px rgba(0, 0, 0, 0.08);\n\n  @media #{$max1599} {\n    font-size: 14px;\n  }\n  @media #{$max1366} {\n    font-size: 14px;\n  }\n  @media #{$max1199} {\n    padding-top: 8px;\n    padding-bottom: 8px;\n  }\n\n  .navbar-toggler{\n    &:focus{\n      box-shadow: none;\n    }\n  }\n  .navbar-nav{\n    .nav-link{\n      @media #{$max1366} {\n        white-space: nowrap;\n      }\n    }\n  }\n\n  .navbar-collapse{    \n      @media #{$max1400} {\n        width: 100%;\n        background-color: #ffffff;\n        position: absolute;\n        right: 0;\n        top: 90px;     \n        margin-top: 30px; \n    }\n      @media #{$max767} {        \n        top: 78px;      \n    }\n  }\n  .navbar-brand{\n    img{\n      @media #{$max767} {\n        width: 100px;\n      }\n      @media #{$max575} {\n        width: 80px;\n      }\n      @media #{$max1599} {\n        width: 120px;\n      }\n\n    }\n  }\n  \n\n  .navbar-wrap {\n    align-items: center;\n    background: inherit;\n    display: flex;\n    height: 100%;\n    justify-content: space-between;\n    margin: 0 auto;\n    min-height: inherit;\n    padding: 0 $module-rem;\n    position: relative;\n\n    > * {\n      margin: 0 $module-rem;\n    }\n    .navbar-close {\n      color: inherit;\n      cursor: pointer;\n      font-size: 30px;\n      position: absolute;\n      right: $module-rem;\n      top: calc($module-rem * 1.5);\n      width: auto !important;\n      z-index: 1;\n    }\n    .add-patient {\n      height: 100%;\n      padding: calc($module-rem * 2) calc($module-rem * 4);\n    }\n    .assistant-menu {\n      display: block;\n      padding: 0 calc($module-rem * 4) calc($module-rem * 2);\n\n      .link {\n        color: inherit;\n        display: block;\n        font-weight: 700;\n        opacity: 0.3;\n        padding: calc($module-rem / 2) 0;\n        transition: opacity 0.2s $animation;\n\n        .link-icon {\n          margin-right: $module-rem;\n          padding: 0;\n          font-size: 1.3em;\n        }\n        &:hover {\n          opacity: 1;\n        }\n      }\n    }\n    .navbar-toggle {\n      align-items: center;\n      color: inherit;\n      cursor: pointer;\n      display: flex;\n      flex-direction: column;\n      height: 40px;\n      justify-content: center;\n      width: 35px;\n\n      span {\n        background: main-palette(500);\n        display: block;\n        height: 3px;\n        margin: 4px 0;\n        width: 35px;\n      }\n    }\n  }\n  &.boxed {\n    .navbar-wrap {\n      max-width: $boxed-width;\n      max-width: var(--boxed-width);\n    }\n  }\n  &.horizontal-vertical {\n    @media #{$max991} {\n      display: flex;\n      justify-content: flex-end;\n      height: 100%;\n      left: 0;\n      position: absolute;\n      top: 0;\n      transform: translateX(-$vertical-navbar-width);\n      transition: transform 0.2s $animation;\n      width: $vertical-navbar-width;\n      will-change: transform, width;\n      z-index: 997;\n\n      .navbar-wrap {\n        align-items: flex-start;\n        flex-direction: column;\n        height: 100%;\n        justify-content: flex-start;\n        overflow: auto;\n        padding: 0;\n        width: $vertical-navbar-width;\n\n        > * {\n          margin: 0;\n          width: 100%;\n        }\n      }\n      &.opened {\n        transform: translateX(0);\n      }\n    }\n  }\n  &.vertical {\n    --navbar-bg: #fbfbfb;\n\n    display: flex;\n    justify-content: flex-end;\n    height: 100%;\n    left: 0;\n    overflow: auto;\n    position: absolute;\n    top: 0;\n    transition: transform 0.2s $animation;\n    width: $vertical-navbar-width;\n    will-change: transform, width;\n    -webkit-overflow-scrolling: touch;\n    z-index: 998;\n\n    @media #{$max991} {\n      transform: translateX(-$vertical-navbar-width);\n    }\n\n    .navbar-wrap {\n      align-items: flex-start;\n      flex-direction: column;\n      height: 100%;\n      justify-content: flex-start;\n      padding: 0;\n      width: $vertical-navbar-width;\n      > * {\n        margin: 0;\n        width: 100%;\n      }\n    }\n    &.opened {\n      transform: translateX(0);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
